import { http } from "@canvas/api";
import store from "@/store";

export interface BouncerUserSearchReq {
  endpoint: "bouncer.v2.users.search";
  queryType?: "PERSON";
  queryString?: string;
}

export interface BouncerUserRes {
  start: number;
  total_records: number;
  fetch_records: number;
  items: Array<{
    id: number;
    uid: string;
    email: string;
    first_name: string;
    last_name: string;
    display_name: string;
    type: string;
    image_url: string;
    is_enabled: true;
    created_at: string;
    updated_at: string;
    created_by_id: number;
    updated_by_id: number;
    org_id: number;
    is_employee: true;
    start_date: string;
    status: string;
    change_password: false;
    city: { id: number };
    person_type: { id: number };
    roles: Array<{
      id: number;
      name: string;
      display_name: string;
      type: string;
      created_at: string;
      updated_at: string;
    }>;
  }>;
}

export function get(req: BouncerUserSearchReq): Promise<BouncerUserRes> {
  let filters = [];
  if (req.queryType) {
    filters.push(`type:${req.queryType}`);
  }

  let filterpart = "";
  if (filters.length > 0) {
    filterpart = `&filters=${filters.join(";")};`;
  }

  let querypart = "";
  if (req.queryString) {
    querypart = `&q=${req.queryString}`;
  }
  const endpoint = store.state.appModule.config && store.state.appModule.config.serviceConfigMap.bouncer;

  return http
    .GET(
      `/${endpoint}/v2/users/search?include=roles&start=0&count=25${filterpart}${querypart}`
    )
    .then((response: BouncerUserRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
